import React, { Component } from 'react'

export default class mainContact extends Component {
  render() {
    return (
        <div className='mainContact'>
        <h1>Contact Us</h1>
        <p>Get in Touch with Us Today!
            Connect with our team for inquiries, support, or collaborations.</p>
    </div>
    )
  }
}
